import { useDispatch } from 'react-redux'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useBasePath } from 'components/Providers'
import { IconButton, TableCell, TableRow } from '@mui/material'
import { Link as NavLink } from 'react-router-dom'
import { EditIcon, DeleteIcon } from 'components/Icons'
import Confirm from 'components/Dialog'
import { destroy } from 'store/settings/room'

export default function RoomItem({ room, hasReadWritePermission }) {
  const [confirm, setConfirm] = useState(false)
  const dispatch = useDispatch()
  const basePath = useBasePath()
  const { t } = useTranslation()

  const onConfirm = () => {
    setConfirm(false)
    dispatch(destroy({ id: room.id }))
  }

  return (
    <TableRow hover>
      <TableCell>
        {room.name}
      </TableCell>
      {hasReadWritePermission && (
        <TableCell align="left" sx={{ pl: 0 }}>
          <IconButton component={NavLink} to={`${basePath}/${room.id}`} aria-label={t('edit')}>
            <EditIcon />
          </IconButton>
          <IconButton
            aria-label={t('delete')}
            onClick={() => {
              setConfirm(true)
            }}
          >
            <DeleteIcon />
          </IconButton>
        </TableCell>
      )}
      <Confirm open={confirm} onClose={() => setConfirm(false)} onConfirm={onConfirm} />
    </TableRow>
  )
}
